import Vue from 'vue'
import App from './App.vue'
import './styles/global.css'

new Vue({
  render: h => h(App)
}).$mount('#app')
